export var URL = {
  AIF_BACKEND_URL: process.env.REACT_APP_AIF_BACKEND_URL,
  SAAS_URL: process.env.REACT_APP_SAAS_URL,
  SAAS_URL_ONBOARD: process.env.REACT_APP_SAAS_URL_ONBOARD,
  SAAS_IDM: process.env.REACT_APP_SAAS_IDM,
  SAAS_CODE_URL: process.env.REACT_APP_SAAS_CODE_URL,
  FUND: process.env.REACT_APP_FUND ? process.env.REACT_APP_FUND : "161",
};
export var SAAS_AUTH = {
  COGNITO_APPNAME: process.env.REACT_APP_COGNITO_APPNAME
    ? process.env.REACT_APP_COGNITO_APPNAME
    : "kfinAlternates",
  TENET_CODE: process.env.REACT_APP_TENET_CODE
    ? process.env.REACT_APP_TENET_CODE
    : "2633709306",
  COGNITO_APPLICATION_ID: process.env.REACT_APP_COGNITO_APPLICATION_ID
    ? process.env.REACT_APP_COGNITO_APPLICATION_ID
    : "a8627e8a-95ba-44f4-852a-4496629efe2b",
  REGION: process.env.REACT_APP_REGION
    ? process.env.REACT_APP_REGION
    : "ap-south-1",
  CONGNITO_AUTHENTICATION_FLOW_TYPE: process.env
    .REACT_APP_CONGNITO_AUTHENTICATION_FLOW_TYPE
    ? process.env.REACT_APP_CONGNITO_AUTHENTICATION_FLOW_TYPE
    : "CUSTOM_AUTH",
  SAAS_ENCRYPTION: process.env.REACT_APP_SAAS_ENCRYPTION
    ? process.env.REACT_APP_SAAS_ENCRYPTION.replace(/\s/g, "") === "true"
    : true,
  API_KEY: process.env.REACT_APP_API_KEY,
  SERVER_ENCRYPTION_KEY: process.env.REACT_APP_SERVER_ENCRYPTION_KEY,
  SAAS_ENCRYPTION_KEY: process.env.REACT_APP_SAAS_ENCRYPTION_KEY,
  SECURELS_ENCRYPTION_KEY: process.env.REACT_APP_SECURELS_ENCRYPTION_KEY,
  FUSION_CHART_LICENSE: process.env.REACT_APP_FUSION_CHART_LICENSE,
};

// These details should be maintain in ENV , to disable end-user accessibility
export var AMC_DETAILS = {
  INVESTMENT_TYPE: process.env.REACT_APP_INVESTMENT_TYPE,
  // INVESTMENT_TYPE: "closeEnded", // Available options ["closeEnded","openEnded"]
  FUND_CATEGORY: process.env.REACT_APP_FUND_CATEGORY
    ? process.env.REACT_APP_FUND_CATEGORY.split(",")
    : ["CAT-II", "CAT-III"], // Available option "CAT-II","CAT-III","CAT-II,CAT-III"
  USER_PORTAL: process.env.REACT_APP_USER_PORTAL, // Available options ["INV","DIS","BOTH"]
  ENABLE_BROKERAGE: false, // Available Option true or false
  COLOR_CODE: {
    LEFT_NAV: "#002247",
    LEFT_NAV_BUTTON_BG: "#014085",
    LEFT_NAV_BUTTON: "#FEFEFF",
    THEME_ELEMENT_COLOR: "#2057A6",
  },
};

export var USE_DEFAULT = process.env.REACT_APP_USE_DEFAULT
  ? process.env.REACT_APP_USE_DEFAULT.replace(/\s/g, "") === "true"
  : false; // IF true then use default value as mentioned above or else use api to fetch

export var SECURE_LS_ENCRYPT = process.env.REACT_APP_SECURE_LS_ENCRYPT
  ? process.env.REACT_APP_SECURE_LS_ENCRYPT.replace(/\s/g, "") === "true"
  : true; // IF true encrypt local storage
